module.exports = __webpack_public_path__ + "media/icons/paliwa-menu@2x-3612ce21.png";